// extracted by mini-css-extract-plugin
export default {"ReposCountText":"ReposList-module__ReposCountText--A_sIJ","ReposListContainer":"ReposList-module__ReposListContainer--vevmF"};